import { jsxs as h, jsx as r } from "react/jsx-runtime";
import { E as _, S as g } from "./icons.types-0722eef5.js";
function f({ title: a, titleId: n, size: l, width: o, height: e, extended: d = !1, ...c }) {
  const i = d ? _ : g, s = l ? i[l] : o || i[d ? "s" : "l"], t = l ? i[l] : e || i[d ? "s" : "l"];
  return /* @__PURE__ */ h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: s,
      height: t,
      "aria-labelledby": n,
      ...c,
      children: [
        a ? /* @__PURE__ */ r("title", { id: n, children: a }) : null,
        /* @__PURE__ */ r("g", { clipPath: "url(#Share__Android_svg__a)", children: /* @__PURE__ */ r("g", { clipPath: "url(#Share__Android_svg__b)", children: /* @__PURE__ */ r(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M59.66.075c6.645 0 12.033 5.388 12.033 12.034 0 6.646-5.388 12.034-12.034 12.034a12.014 12.014 0 0 1-9.528-4.682L23.943 32.555c.325 1.091.5 2.248.5 3.445 0 1.197-.175 2.354-.5 3.445L50.169 52.56a12.014 12.014 0 0 1 9.49-4.634c6.646 0 12.034 5.388 12.034 12.034 0 6.646-5.388 12.034-12.034 12.034-6.646 0-12.034-5.388-12.034-12.034 0-.912.102-1.8.294-2.655L21.372 44.031a12.004 12.004 0 0 1-8.963 4.003C5.763 48.034.375 42.646.375 36c0-6.646 5.388-12.034 12.034-12.034 3.56 0 6.76 1.546 8.963 4.003l26.533-13.267a12.076 12.076 0 0 1-.28-2.593c0-6.646 5.388-12.034 12.034-12.034Zm0 53.1a6.784 6.784 0 1 0-.001 13.568 6.784 6.784 0 0 0 0-13.568Zm-47.25-23.96a6.784 6.784 0 1 0-.001 13.569 6.784 6.784 0 0 0 0-13.568Zm47.25-23.89a6.784 6.784 0 1 0-.001 13.568 6.784 6.784 0 0 0 0-13.568Z",
            clipRule: "evenodd"
          }
        ) }) }),
        /* @__PURE__ */ h("defs", { children: [
          /* @__PURE__ */ r("clipPath", { id: "Share__Android_svg__a", children: /* @__PURE__ */ r(
            "path",
            {
              fill: "currentColor",
              d: "M0 0h72v72H0z"
            }
          ) }),
          /* @__PURE__ */ r("clipPath", { id: "Share__Android_svg__b", children: /* @__PURE__ */ r(
            "path",
            {
              fill: "currentColor",
              d: "M0 0h72v72H0z"
            }
          ) })
        ] })
      ]
    }
  );
}
export {
  f as ShareAndroid
};
